import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import "regenerator-runtime/runtime";
/* global ethereum*/

import { reduce } from 'async';

var EmbarkJS = global.EmbarkJS || require('embarkjs');

EmbarkJS = EmbarkJS.default || EmbarkJS;

var ENSFunctions = require('./ENSFunctions').default;

var Web3 = require('web3');

var namehash = require('eth-ens-namehash');

var __embarkENS = {};
__embarkENS.ENSFunctions = ENSFunctions; // resolver interface

__embarkENS.resolverInterface = [{
  "constant": true,
  "inputs": [{
    "name": "node",
    "type": "bytes32"
  }],
  "name": "addr",
  "outputs": [{
    "name": "",
    "type": "address"
  }],
  "type": "function"
}, {
  "constant": true,
  "inputs": [{
    "name": "node",
    "type": "bytes32"
  }],
  "name": "content",
  "outputs": [{
    "name": "",
    "type": "bytes32"
  }],
  "type": "function"
}, {
  "constant": true,
  "inputs": [{
    "name": "node",
    "type": "bytes32"
  }],
  "name": "name",
  "outputs": [{
    "name": "",
    "type": "string"
  }],
  "type": "function"
}, {
  "constant": false,
  "inputs": [{
    "name": "node",
    "type": "bytes32"
  }, {
    "name": "addr",
    "type": "address"
  }],
  "name": "setAddr",
  "outputs": [],
  "type": "function"
}, {
  "constant": false,
  "inputs": [{
    "name": "node",
    "type": "bytes32"
  }, {
    "name": "hash",
    "type": "bytes32"
  }],
  "name": "setContent",
  "outputs": [],
  "type": "function"
}, {
  "constant": false,
  "inputs": [{
    "name": "node",
    "type": "bytes32"
  }, {
    "name": "name",
    "type": "string"
  }],
  "name": "setName",
  "outputs": [],
  "type": "function"
}, {
  "constant": true,
  "inputs": [{
    "name": "node",
    "type": "bytes32"
  }, {
    "name": "contentType",
    "type": "uint256"
  }],
  "name": "ABI",
  "outputs": [{
    "name": "",
    "type": "uint256"
  }, {
    "name": "",
    "type": "bytes"
  }],
  "payable": false,
  "type": "function"
}];
var defaultAccountNotSetError = 'web3.eth.defaultAccount not set';
var providerNotSetError = 'ENS provider not set';
var NoDecodeAddrError = 'Error: Couldn\'t decode address from ABI: 0x';
var NoDecodeStringError = 'ERROR: The returned value is not a convertible string: 0x0';
var reverseAddrSuffix = '.addr.reverse';
var voidAddress = '0x0000000000000000000000000000000000000000';
__embarkENS.registryAddresses = {
  // Mainnet
  "1": "0x314159265dd8dbb310642f98f50c066173c1259b",
  // Ropsten
  "3": "0x112234455c3a32fd11230c42e7bccd4a84e02010",
  // Rinkeby
  "4": "0xe7410170f87102DF0055eB195163A03B7F2Bff4A"
};

function setProvider(web3, kind, endpoint) {
  web3.setProvider(new Web3.providers[kind](endpoint));
}

function connectWebSocket(web3, endpoint, callback) {
  setProvider(web3, 'WebsocketProvider', endpoint);
  checkConnection(web3, callback);
}

function connectHttp(web3, endpoint, callback) {
  setProvider(web3, 'HttpProvider', endpoint);
  checkConnection(web3, callback);
}

function connectWeb3(web3, callback) {
  return _regeneratorRuntime.async(function connectWeb3$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(typeof window !== 'undefined' && window.ethereum)) {
            _context.next = 12;
            break;
          }

          _context.prev = 1;

          if (!this.dappAutoEnable) {
            _context.next = 5;
            break;
          }

          _context.next = 5;
          return _regeneratorRuntime.awrap(ethereum.enable());

        case 5:
          web3.setProvider(ethereum);
          return _context.abrupt("return", checkConnection(callback));

        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", callback(null, {
            error: _context.t0,
            connected: false
          }));

        case 12:
          callback(null, {
            connected: false,
            error: new Error("web3 provider not detected")
          });

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, null, this, [[1, 9]]);
}

function checkConnection(web3, callback) {
  web3.eth.getAccounts(function (error) {
    if (error) {
      web3.setProvider(null);
    }

    callback(null, {
      connected: !error,
      error: error
    });
  });
}

__embarkENS.web3 = new Web3();

__embarkENS.setProvider = function (config) {
  var _this = this;

  var ERROR_MESSAGE = 'ENS is not available in this chain';
  this.registration = config.registration;
  this.env = config.env;
  this.ready = false;
  this.dappAutoEnable = config.dappAutoEnable;
  reduce(config.dappConnection, false, function (result, connectionString, next) {
    if (result.connected) {
      return next(null, result);
    }

    if (connectionString === '$WEB3') {
      connectWeb3(_this.web3, next);
    } else if (/^wss?:\/\//.test(connectionString)) {
      connectWebSocket(_this.web3, connectionString, next);
    } else {
      connectHttp(_this.web3, connectionString, next);
    }
  }, function _callee(err, result) {
    var accounts, id, registryAddress, _context2;

    return _regeneratorRuntime.async(function _callee$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (result.error) {
              console.error(result.error);
            }

            _context3.prev = 1;
            _context3.next = 4;
            return _regeneratorRuntime.awrap(_this.web3.eth.getAccounts());

          case 4:
            accounts = _context3.sent;
            _this.web3.eth.defaultAccount = accounts[0];
            _context3.next = 8;
            return _regeneratorRuntime.awrap(_this.web3.eth.net.getId());

          case 8:
            id = _context3.sent;
            registryAddress = _this.registryAddresses[id] || config.registryAddress;
            _this._isAvailable = true;
            _this.ens = new _this.web3.eth.Contract(config.registryAbi, registryAddress);
            _this.registrar = new _this.web3.eth.Contract(config.registrarAbi, config.registrarAddress);
            _this.resolver = new _this.web3.eth.Contract(config.resolverAbi, config.resolverAddress);
            _this.ready = true;
            _context3.next = 24;
            break;

          case 17:
            _context3.prev = 17;
            _context3.t0 = _context3["catch"](1);
            _this.ready = true;

            if (!(_indexOfInstanceProperty(_context2 = _context3.t0.message).call(_context2, 'Provider not set or invalid') > -1)) {
              _context3.next = 23;
              break;
            }

            console.warn(ERROR_MESSAGE);
            return _context3.abrupt("return");

          case 23:
            console.error(_context3.t0);

          case 24:
          case "end":
            return _context3.stop();
        }
      }
    }, null, null, [[1, 17]]);
  });
};

__embarkENS.waitForProviderReady = function () {
  var _this2 = this;

  return new _Promise(function (resolve, reject) {
    var self = _this2;

    function checkReady() {
      if (self.ready === undefined) {
        return reject(providerNotSetError);
      }

      if (self.ready) {
        if (!self.ens) {
          return reject(providerNotSetError);
        }

        return resolve();
      }

      _setTimeout(checkReady, 100);
    }

    checkReady();
  });
};

__embarkENS.resolve = function (name, callback) {
  var _this3 = this;

  var resolve = function resolve(name) {
    var node, resolvedAddress, resolverContract, msg;
    return _regeneratorRuntime.async(function resolve$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _regeneratorRuntime.awrap(_this3.waitForProviderReady());

          case 2:
            if (_this3.web3.eth.defaultAccount) {
              _context4.next = 4;
              break;
            }

            throw new Error(defaultAccountNotSetError);

          case 4:
            node = namehash.hash(name);
            _context4.prev = 5;
            _context4.next = 8;
            return _regeneratorRuntime.awrap(_this3.ens.methods.resolver(node).call());

          case 8:
            resolvedAddress = _context4.sent;

            if (!(resolvedAddress === voidAddress)) {
              _context4.next = 11;
              break;
            }

            throw new Error('Name not yet registered');

          case 11:
            resolverContract = new _this3.web3.eth.Contract(_this3.resolverInterface, resolvedAddress);
            _context4.next = 14;
            return _regeneratorRuntime.awrap(resolverContract.methods.addr(node).call());

          case 14:
            return _context4.abrupt("return", _context4.sent);

          case 17:
            _context4.prev = 17;
            _context4.t0 = _context4["catch"](5);
            msg = _context4.t0.message;

            if (!(msg === NoDecodeAddrError)) {
              _context4.next = 22;
              break;
            }

            throw new Error("".concat(name, " is not registered"));

          case 22:
            throw _context4.t0;

          case 23:
          case "end":
            return _context4.stop();
        }
      }
    }, null, null, [[5, 17]]);
  };

  if (callback) {
    resolve(name).then(function (result) {
      callback(null, result);
    }).catch(callback);
    return;
  }

  return resolve(name);
};

__embarkENS.lookup = function (address, callback) {
  var _this4 = this;

  var lookup = function lookup(address) {
    var node, resolverAddress, resolverContract, msg;
    return _regeneratorRuntime.async(function lookup$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _regeneratorRuntime.awrap(_this4.waitForProviderReady());

          case 2:
            if (_this4.web3.eth.defaultAccount) {
              _context5.next = 4;
              break;
            }

            throw new Error(defaultAccountNotSetError);

          case 4:
            if (_startsWithInstanceProperty(address).call(address, "0x")) {
              address = _sliceInstanceProperty(address).call(address, 2);
            }

            node = namehash.hash(address.toLowerCase() + reverseAddrSuffix);
            _context5.prev = 6;
            _context5.next = 9;
            return _regeneratorRuntime.awrap(_this4.ens.methods.resolver(node).call());

          case 9:
            resolverAddress = _context5.sent;

            if (!(resolverAddress === voidAddress)) {
              _context5.next = 12;
              break;
            }

            throw new Error('Address not associated to a resolver');

          case 12:
            resolverContract = new _this4.web3.eth.Contract(_this4.resolverInterface, resolverAddress);
            _context5.next = 15;
            return _regeneratorRuntime.awrap(resolverContract.methods.name(node).call());

          case 15:
            return _context5.abrupt("return", _context5.sent);

          case 18:
            _context5.prev = 18;
            _context5.t0 = _context5["catch"](6);
            msg = _context5.t0.message;

            if (!(msg === NoDecodeStringError || msg === NoDecodeAddrError)) {
              _context5.next = 23;
              break;
            }

            throw new Error('Address does not resolve to name. Try syncing chain.');

          case 23:
            throw _context5.t0;

          case 24:
          case "end":
            return _context5.stop();
        }
      }
    }, null, null, [[6, 18]]);
  };

  if (callback) {
    lookup(address).then(function (result) {
      callback(null, result);
    }).catch(callback);
    return;
  }

  return lookup(address);
};

__embarkENS.registerSubDomain = function (name, address, callback) {
  callback = callback || function () {};

  if (!this.web3.eth.defaultAccount) {
    return callback(defaultAccountNotSetError);
  }

  if (this.env !== 'development' && this.env !== 'privatenet') {
    return callback('Sub-domain registration is only available in development or privatenet mode');
  }

  if (!this.registration || !this.registration.rootDomain) {
    return callback('No rootDomain is declared in config/namesystem.js (register.rootDomain). Unable to register a subdomain until then.');
  }

  if (!address || !Web3.utils.isAddress(address)) {
    return callback('You need to specify a valid address for the subdomain');
  } // Register function generated by the index


  ENSFunctions.registerSubDomain(this.web3, this.ens, this.registrar, this.resolver, this.web3.eth.defaultAccount, name, this.registration.rootDomain, namehash.hash(address.toLowerCase().substr(2) + reverseAddrSuffix), address, console, EmbarkJS.Utils.secureSend, function (err, result) {
    if (err && _indexOfInstanceProperty(err).call(err, 'Transaction has been reverted by the EVM') > -1) {
      return callback('Registration was rejected. Are you the owner of the root domain?');
    }

    callback(err, result);
  });
};

__embarkENS.isAvailable = function () {
  return Boolean(this._isAvailable);
};

export default __embarkENS;